import { Button } from '@mui/material';
import { ComponentProps } from 'react';

export const getJoinCallButtonStyle = (): ComponentProps<typeof Button> => ({
  variant: 'contained',
  sx: {
    textTransform: 'none',
  },
});
